import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { TransactionMode, } from '@tencent/memoire-core';
import { IDBEngineCursor } from './cursor';
import { IDBEngineIndex } from './database-index';
var IDBEngineTable = /** @class */ (function () {
    function IDBEngineTable(mode, objectStore, engineAspects, transaction) {
        this.mode = mode;
        this.objectStore = objectStore;
        this.engineAspects = engineAspects;
        this.transaction = transaction;
        this.createIndex = undefined;
        this.delete = undefined;
        this.bulkDelete = undefined;
        this.clear = undefined;
        this.insert = undefined;
        this.upsert = undefined;
        this.deleteIndex = undefined;
        this.bulkUpsert = undefined;
        this.keyPath = objectStore.keyPath;
        this.autoIncrement = objectStore.autoIncrement;
        this.tableName = objectStore.name;
        this.indexNames = __spreadArray([], __read(objectStore.indexNames));
        this.initWriteFun(mode);
        if (engineAspects === null || engineAspects === void 0 ? void 0 : engineAspects.table) {
            this.applyAspectPatch();
        }
    }
    IDBEngineTable.prototype.query = function () {
        throw new Error('query Method is not support for IDB.');
    };
    IDBEngineTable.prototype.supports = function (method) {
        var unSupportMethods = ['query', 'bulkDelete'];
        return !unSupportMethods.includes(method);
    };
    IDBEngineTable.prototype.index = function (indexName) {
        var proxyIndex = this.objectStore.index(indexName);
        return new IDBEngineIndex(this, proxyIndex, this.mode, this.engineAspects);
    };
    IDBEngineTable.prototype.getAll = function (query) {
        return this.objectStore.getAll(query);
    };
    IDBEngineTable.prototype.getAllKeys = function (query, count) {
        return this.objectStore.getAllKeys(query, count);
    };
    IDBEngineTable.prototype.get = function (query) {
        var _a;
        return (_a = this.objectStore.get(query)) !== null && _a !== void 0 ? _a : null;
    };
    IDBEngineTable.prototype.openCursor = function (query, direction) {
        return __awaiter(this, void 0, void 0, function () {
            var idbCursor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.objectStore.openCursor(query, direction)];
                    case 1:
                        idbCursor = _a.sent();
                        if (!idbCursor) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, new IDBEngineCursor(this.mode, idbCursor, direction !== null && direction !== void 0 ? direction : 'next')];
                }
            });
        });
    };
    IDBEngineTable.prototype.initWriteFun = function (mode) {
        var _this = this;
        if (mode === TransactionMode.VERSION_CHANGE) {
            this.createIndex = this.createIndexFun;
            this.deleteIndex = (function (indexName) {
                return _this.getProxyObjectStoreWithMode().deleteIndex(indexName);
            });
        }
        if (mode !== TransactionMode.READ_ONLY) {
            this.delete = (function (query) {
                return _this.getProxyObjectStoreWithMode().delete(query);
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.bulkDelete = (function (keys) {
                throw new Error('bulkDelete Method is not support for IDB.');
            });
            this.clear = (function () {
                return _this.getProxyObjectStoreWithMode().clear();
            });
            this.insert = (function (value) {
                return _this.getProxyObjectStoreWithMode().add(value);
            });
            this.upsert = (function (value) {
                return _this.getProxyObjectStoreWithMode().put(value);
            });
            this.bulkUpsert = (function (values) {
                var objectStore = _this.getProxyObjectStoreWithMode();
                var allReqPromise = values.reduce(function (preValue, currentValue) {
                    preValue.push(objectStore.put(currentValue));
                    return preValue;
                }, []);
                return Promise.all(allReqPromise);
            });
        }
    };
    IDBEngineTable.prototype.createIndexFun = function (indexName, key, indexOptions) {
        var table = this.getProxyObjectStoreWithMode();
        return new IDBEngineIndex(this, table.createIndex(indexName, key, indexOptions), this.mode);
    };
    IDBEngineTable.prototype.getProxyObjectStoreWithMode = function () {
        return this.objectStore;
    };
    /**
     * bind the hook stub to the table object
     */
    IDBEngineTable.prototype.applyAspectPatch = function () {
        var _a;
        var tableAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.table;
        if (this.mode === TransactionMode.READ_ONLY) {
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.get.patch(this, 'get');
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.getAll.patch(this, 'getAll');
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.getAllKeys.patch(this, 'getAllKeys');
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.index.patch(this, 'index');
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.openCursor.patch(this, 'openCursor');
            return;
        }
        if (this.mode === TransactionMode.VERSION_CHANGE) {
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.createIndex.patch(this, 'createIndex');
            tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.deleteIndex.patch(this, 'deleteIndex');
        }
        tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.delete.patch(this, 'delete');
        tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.insert.patch(this, 'insert');
        tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.upsert.patch(this, 'upsert');
        tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.bulkUpsert.patch(this, 'bulkUpsert');
        tableAspects === null || tableAspects === void 0 ? void 0 : tableAspects.clear.patch(this, 'clear');
    };
    return IDBEngineTable;
}());
export { IDBEngineTable };
//# sourceMappingURL=table.js.map